import WelcomeBanner from './WelcomeBanner';
import '../../../../../../utils/i18n'

export default WelcomeBanner;
